import { render } from "./SchoolCourseGroupForm.vue?vue&type=template&id=4f84409e&scoped=true"
import script from "./SchoolCourseGroupForm.vue?vue&type=script&lang=js"
export * from "./SchoolCourseGroupForm.vue?vue&type=script&lang=js"

import "./SchoolCourseGroupForm.vue?vue&type=style&index=0&id=4f84409e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f84409e"]])

export default __exports__